import React from "react";

// Normalize any legacy `byline` shape (missing / string / partial object) into
// the canonical { text, bold, italic, size } object that ProductCard expects.
export const normalizeByline = (b) => {
  if (!b) return { text: "", bold: true, italic: false, size: "small" };
  if (typeof b === "string") return { text: b, bold: true, italic: false, size: "small" };
  return { text: b.text || "", bold: b.bold !== false, italic: !!b.italic, size: b.size || "small" };
};

export const BylineEditor = ({ value, onChange }) => {
  const v = value || { text: "", bold: true, italic: false, size: "small" };
  const patch = (k, val) => onChange({ ...v, [k]: val });
  return (
    <div className="rounded-xl border border-[#262626] bg-[#141414] p-4 space-y-3" data-testid="byline-editor">
      <div>
        <label className="text-xs uppercase tracking-widest text-[#A3A3A3]">Byline</label>
        <input
          type="text"
          data-testid="byline-text"
          value={v.text || ""}
          onChange={(e) => patch("text", e.target.value)}
          placeholder="e.g. For Graphic Designers & Content Creators"
          className="mt-2 w-full bg-[#0F0F0F] border border-[#262626] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#FF6600]"
        />
        <div className="text-[11px] text-[#A3A3A3] mt-1">
          Rendered under the card title, muted relative to the heading. Leave blank to hide entirely.
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <label className="flex items-center gap-2 text-sm text-white cursor-pointer select-none">
          <input
            type="checkbox"
            data-testid="byline-bold"
            checked={v.bold !== false}
            onChange={(e) => patch("bold", e.target.checked)}
            className="w-4 h-4 accent-[#FF6600]"
          />
          Bold
        </label>
        <label className="flex items-center gap-2 text-sm text-white cursor-pointer select-none">
          <input
            type="checkbox"
            data-testid="byline-italic"
            checked={!!v.italic}
            onChange={(e) => patch("italic", e.target.checked)}
            className="w-4 h-4 accent-[#FF6600]"
          />
          Italic
        </label>
        <div>
          <select
            data-testid="byline-size"
            value={v.size || "small"}
            onChange={(e) => patch("size", e.target.value)}
            className="w-full bg-[#0F0F0F] border border-[#262626] rounded-lg px-3 py-1.5 text-sm text-white focus:outline-none focus:border-[#FF6600]"
          >
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
        </div>
      </div>
    </div>
  );
};
